import React, { Component } from 'react';

import { number, bool } from 'prop-types';
import { connect } from 'react-redux';
import { withState } from 'recompose';

import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';

import Button from 'components/Common/Buttons/ButtonV3';
import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';

import withRouter from 'containers/withRouter';
import { RouterPropTypes } from 'propTypes/RouterPropTypes';

import { MESSAGES } from 'routes/constants';

import s from './Messages.css';

@withState('anchor', 'setAnchor', null)
@withRouter
@connect(
  ({ notifications: { unseenMessageCenterCount } }) => ({
    unseenMessageCenterCount,
  }),
  null,
)
export default class Messages extends Component {
  render() {
    const {
      unseenMessageCenterCount,
      router: { navigate },
      disabled,
    } = this.props;

    return unseenMessageCenterCount === 0 ? (
      <Button
        compactVariant="default"
        className={s.iconButton}
        icon={<FontAwesomeIcon icon={faEnvelope} color="white" />}
        onClick={() => {
          if (!disabled) navigate(MESSAGES);
        }}
      />
    ) : (
      <Button
        badgeCount={
          unseenMessageCenterCount > 99 ? '99+' : unseenMessageCenterCount
        }
        color="red"
        compactVariant="default"
        className={s.iconButton}
        icon={<FontAwesomeIcon icon={faEnvelope} color="white" />}
        onClick={() => {
          if (!disabled) navigate(MESSAGES);
        }}
      />
    );
  }
}

Messages.propTypes = {
  unseenMessageCenterCount: number,
  disabled: bool,
  router: RouterPropTypes,
};

Messages.defaultProps = {
  disabled: false,
  unseenMessageCenterCount: null,
  router: {},
};
